import { render } from "./circular.vue?vue&type=template&id=22161dff&scoped=true"
import script from "./circular.vue?vue&type=script&lang=js"
export * from "./circular.vue?vue&type=script&lang=js"

import "./circular.vue?vue&type=style&index=0&id=22161dff&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22161dff"]])

export default __exports__